import React from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { DatePicker, AutoComplete } from 'formik-antd';
import AddressComponent from 'components/AddressComponent';
import { IProps, IState } from './types';
import { InsureProcessFillState, InsureProcessFillFormValue } from 'constants/models/components/insureProcessCar/insureProcessFill';
import service from 'bff/services/carProductService';
import { EmailDomain, SysOption } from 'bff/models/info';
import _ from 'lodash';
import InputWithRegex from 'components/InputWithRegex';
import { mobileRegex, emailRegex } from 'utils/commonValidations';
import { PolicyDelivery } from 'constants/enums/policyDelivery.enum';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
// import moment from 'moment';
import moment from 'moment-timezone';
import { NationalType } from 'constants/enums/nationalType.enum';
import memberProfileService from 'bff/services/memberProfileService';
import { InsuredRelation } from 'constants/enums/insuredRelation.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { MemberProfile } from 'bff/models/member';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { CheckVehicleApplyTypeReq, VehiclePolicyNoReq, ValidVehicleInsCommonRuleRes, ValidVehicleBlackListRes, VehicleInsCommonRuleCheckContent } from 'bff/models/product';
import { InprocessSelectFormValue, InprocessSelectState } from 'constants/models/components/insureProcessCar/inprocessSelect';
import { ApplyNoType } from 'constants/enums/applyNoType.enum';
import { Marriage } from 'constants/enums/marriage.enum';
import { ValidVehicleInsCommonRuleReq } from 'bff/models/product/validVehicleInsCommonRuleReq';
import { ValidVehicleBlackListReq } from 'bff/models/product/validVehicleBlackListReq';
import { RuleCheckInsuredType } from 'constants/enums/ruleCheckInsuredType.enum';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import { Dispatch } from 'redux';
import { setRuleValidErrorModalVisible, setMemberInfoErrorModalVisible } from 'redux/actions/modal.action';
import { connect } from 'react-redux';
import { RootReducersState } from 'redux/reducers';
import { ApplyType } from 'constants/enums/applyType.enum';
import FormikFocusError from 'components/FormikFocusError';
import { PolicyItemListContent } from 'bff/models/product/vehicleItemList';
import { VehicleItemType } from 'constants/enums/vehicleItemType';
import { RouterSettings } from 'constants/models/routerSettings';
import MemberInfoErrorModal from 'components/MemberInfoErrorModal';
import { InsType } from 'constants/enums/insType.enum';
import { InfoCheckmailandmobileReq, InfoCheckmailandmobileResp } from 'bff/models/info/infoCheckmailandmobile';

const initFormVal: InsureProcessFillFormValue = {
  INSURED_NATIONALITY_TYPE: '',
  INSURED_MEMBER_ID: '',
  INSURED_BIRTHDAY: '',
  INSURED_NAME: '',
  INSURED_MARRIAGE: Marriage.Single,
  INSURED_EMAIL: '',
  INSURED_MOBILE: '',
  INSURED_POST_CODE: '',
  INSURED_CITY_ID: '',
  INSURED_AREA_ID: '',
  INSURED_ADDRESS: '',
  INSURED_CITY_ID_NAME: '',
  INSURED_AREA_ID_NAME: '',
  INSURED_JOB_NUMBER: '',
  POLICYHOLDER_RELATION: '',
  POLICYHOLDER_RELATION_NAME: '',
  POLICYHOLDER_NATIONALITY_TYPE: '',
  POLICYHOLDER_MEMBER_ID: '',
  POLICYHOLDER_BIRTHDAY: '',
  POLICYHOLDER_NAME: '',
  POLICYHOLDER_MARRIAGE: Marriage.Single,
  POLICYHOLDER_EMAIL: '',
  POLICYHOLDER_MOBILE: '',
  POLICYHOLDER_POST_CODE: '',
  POLICYHOLDER_CITY_ID: '',
  POLICYHOLDER_CITY_ID_NAME: '',
  POLICYHOLDER_AREA_ID: '',
  POLICYHOLDER_AREA_ID_NAME: '',
  POLICYHOLDER_ADDRESS: '',
  POLICYHOLDER_JOB_NUMBER: '',
  UPDATE_INFO_CHECKED: false,
  DELIVERY: PolicyDelivery.Electric
};

let formInitialValues: InsureProcessFillFormValue = initFormVal;

// 判斷是否顯示會員資料錯誤 Modal
let showMemberInfoErrorModal = false;
// 是否同要/被保人
let samePolicyholder = false;

const toggle = {
  insured: 'insured',
  policy: 'policy'
};

class InsureProcessFill extends React.Component<IProps, IState> {
  private insuredInfoRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private formikRef: any = React.createRef();

  // Validation Schema: 移入類別內，以取得 state 資料執行檢核
  private formValidationSchema = Yup.object().shape({
    INSURED_MEMBER_ID: Yup.string().required('此為必填欄位').when('INSURED_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
      if (nationalityType === NationalType.National) {
        return schema.length(10, '身份證長度為 10 字元').matches(/^[A-Z]\d{9}$/, '身份證格式不符');
      }
      if (nationalityType === NationalType.Foreigner) {
        return schema.length(10, '居留證長度為 10 字元');
      }

      return schema.length(8, '統一編號長度為 8 字元').matches(/^\d{8}$/, '統一編號格式不符');
    }),
    INSURED_BIRTHDAY: Yup.string().when('INSURED_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
      if (nationalityType && nationalityType !== NationalType.Legal) {
        return schema.required('此為必填欄位').nullable();
      }
    }),
    INSURED_NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '姓名長度不可超過 200 字元').test('contain num', '姓名格式不符', (val: string) => {
      if (val) {
        return !(/[\d]+/.test(val));
      }
      return true;
    }),
    INSURED_EMAIL: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(this.props.UICodes, CodeId.W087), (val: string) => {
      if (val && emailRegex.test(val)) {
        const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
        const isBlocked = this.state.blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
        if (isBlocked) return false;
      }
      return true;
    }),
    INSURED_MOBILE: Yup.string().required('此為必填欄位').length(10, '手機號碼長度為 10 字元').test('mobile format', '手機格式不符', (val: string) => {
      if (val) {
        return mobileRegex.test(val);
      }
      return true;
    }),
    INSURED_NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
    INSURED_POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
    INSURED_CITY_ID: Yup.string().required('此為必填欄位'),
    INSURED_AREA_ID: Yup.string().required('此為必填欄位'),
    INSURED_ADDRESS: Yup.string().required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元'),
    POLICYHOLDER_RELATION: Yup.string().required('此為必填欄位'),
    POLICYHOLDER_NATIONALITY_TYPE: Yup.string().required('此為必填欄位'),
    POLICYHOLDER_MEMBER_ID: Yup.string().required('此為必填欄位').when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
      if (nationalityType === NationalType.National) {
        return schema.length(10, '身份證長度為 10 字元').matches(/^[A-Z]\d{9}$/, '身份證格式不符');
      }
      if (nationalityType === NationalType.Foreigner) {
        return schema.length(10, '居留證長度為 10 字元');
      }

      return schema.length(8, '統一編號長度為 8 字元').matches(/^\d{8}$/, '統一編號格式不符');
    }).test('same id', '不可與被保人 ID 相符',
      function (policyholderId) {
        const { INSURED_MEMBER_ID, POLICYHOLDER_RELATION } = this.parent;
        if (POLICYHOLDER_RELATION === InsuredRelation.SameInsured || !policyholderId) return true;

        return policyholderId !== INSURED_MEMBER_ID;
      }),
    POLICYHOLDER_BIRTHDAY: Yup.string().when('POLICYHOLDER_NATIONALITY_TYPE', (nationalityType: string, schema: any) => {
      if (nationalityType && nationalityType !== NationalType.Legal) {
        return schema.required('此為必填欄位').nullable();
      }
    }),
    POLICYHOLDER_NAME: Yup.string().required('此為必填欄位').min(2, '姓名格式錯誤').max(200, '姓名長度不可超過 200 字元').test('contain num', '姓名格式不符', (val: string) => {
      if (val) {
        return !(/[\d]+/.test(val));
      }
      return true;
    }),
    POLICYHOLDER_EMAIL: Yup.string().required('此為必填欄位').matches(emailRegex, '電子信箱格式不符').email('電子信箱格式不符').max(50, '電子信箱長度不可超過 50 字元').test('block domain', commonService.getCodeMsg(this.props.UICodes, CodeId.W087), (val: string) => {
      if (val && emailRegex.test(val)) {
        const snippets = val.split('@'); // 符合格式後進行拆分，以利檢核
        const isBlocked = this.state.blockDomains.find(it => it.EMAIL_DOMAIN_NAME === snippets[1]);
        if (isBlocked) return false;
      }
      return true;
    }),
    POLICYHOLDER_MOBILE: Yup.string().required('此為必填欄位').length(10, '手機號碼長度為 10 字元').test('mobile format', '手機格式不符', (val: string) => {
      if (val) {
        return mobileRegex.test(val);
      }
      return true;
    }),
    POLICYHOLDER_POST_CODE: Yup.string().required('此為必填欄位').max(6, '郵遞區號長度不可超過 6 字元'),
    POLICYHOLDER_CITY_ID: Yup.string().required('此為必填欄位'),
    POLICYHOLDER_AREA_ID: Yup.string().required('此為必填欄位'),
    POLICYHOLDER_ADDRESS: Yup.string().required('此為必填欄位').max(200, '詳細地址長度不可超過 200 字元'),
    INSURED_JOB_NUMBER: Yup.string().required('此為必填欄位'),
    POLICYHOLDER_JOB_NUMBER: Yup.string().required('此為必填欄位')
  });

  state: IState = {
    activeRelation: '',
    activeInsuredNationalityType: '',
    postcodes: new Array(0),
    emailDomains: new Array(0),
    policyDeliverySysOpts: new Array(0),
    relationLSysOpts: new Array(0),
    relationVSysOpts: new Array(0),
    marriageSysOpts: new Array(0),
    polValCodes: new Array(0),
    applyType: '',
    serialNo: '',
    isSelf: false,
    vehicleOwnerInfoFixedVisible: false,
    isLoginComplete: false,
    policyholderIdErrMsg: '',
    promoteLogin: false,
    blockDomains: [],
    hideInsuredID: false,
    hidePolicyID: false
  }

  componentDidMount = async () => {
    showMemberInfoErrorModal = false;
    samePolicyholder = false;
    commonService.scrollToTop();
    this.addWindowScrollEvent();

    // 判斷是否有暫存資料
    const hasTemp = this.props.tempFill && this.props.tempFill.tempFillFormValue && this.props.tempFill.tempFillState;

    const memberId = storageService.getItem(storageKeys.MemberId);

    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;

    // 判斷是否已登入，並取得會員資料
    let memberProfile: any;
    let activeNationalityType = '';
    let activeRelation = '';
    let isSelf = false;
    if (memberId && tempVehicleOwnerInfoFormValue) {
      const ownerId = tempVehicleOwnerInfoFormValue.MEMBER_ID;

      isSelf = ownerId === memberId;
      memberProfile = await memberProfileService.fetchMemberProfile(memberId) as MemberProfile;
      if (!memberProfile) return;

      // 車主頁身份別不是法人，且不是法人，且登入者為車主
      if (tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE !== NationalType.Legal && isSelf) {
        const memberBirthday = moment(moment(memberProfile.BIRTHDAY).format('YYYY/MM/DD'));
        const ownerBirthday = moment(moment(tempVehicleOwnerInfoFormValue.BIRTHDAY).format('YYYY/MM/DD'));
        // 判斷會員生日與車主頁生日是否不一致，提示訊息並導回投保首頁
        if (!memberBirthday.isSame(ownerBirthday)) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: commonService.getCodeMsg(this.props.UICodes, CodeId.W054)
          }).then(() => {
            this.props.onBirthdayError();
          });
          return;
        }
      }
    }

    // 取得網域黑名單
    let blockDomains: EmailDomain[] = [];
    const response = await apiCommonService.fetchBlockDomains();
    if (response) blockDomains = response;

    /**
    * 依不同情況執行不同方法
    * 1. 有暫存資料、登入者 ID、尚未帶入會員資料於被保人
    * 2. 有暫存資料、無登入者 ID
    * 3. 無暫存資料
   */
    if (hasTemp && memberId && !this.props.tempFill.tempFillState?.isLoginComplete && memberProfile) {
      activeNationalityType = memberProfile.NATIONALITY_TYPE;
      console.log('進1');
      this.setState({ hidePolicyID: true });
      showMemberInfoErrorModal = true;
      formInitialValues = {
        ...this.props.tempFill.tempFillFormValue as InsureProcessFillFormValue,
        POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
        POLICYHOLDER_MEMBER_ID: memberProfile.MEMBER_ID,
        POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
        POLICYHOLDER_NAME: memberProfile.NAME,
        POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
        POLICYHOLDER_EMAIL: memberProfile.EMAIL_ADDR,
        POLICYHOLDER_MOBILE: memberProfile.MOBILE,
        POLICYHOLDER_POST_CODE: memberProfile.POST_CODE || '',
        POLICYHOLDER_CITY_ID: memberProfile.CITY_ID || '',
        POLICYHOLDER_CITY_ID_NAME: commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || ''),
        POLICYHOLDER_AREA_ID: memberProfile.AREA_ID || '',
        POLICYHOLDER_AREA_ID_NAME: commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
        POLICYHOLDER_ADDRESS: memberProfile.ADDRESS || '',
        POLICYHOLDER_RELATION: '',
        POLICYHOLDER_RELATION_NAME: ''
      };

      if (isSelf) {
        console.log('進1-1');
        this.setState({ hideInsuredID: true });
        samePolicyholder = true;
        formInitialValues = {
          ...formInitialValues,
          INSURED_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
          INSURED_MEMBER_ID: memberProfile.MEMBER_ID,
          INSURED_BIRTHDAY: memberProfile.BIRTHDAY,
          INSURED_NAME: memberProfile.NAME,
          INSURED_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
          INSURED_EMAIL: memberProfile.EMAIL_ADDR,
          INSURED_MOBILE: memberProfile.MOBILE,
          INSURED_POST_CODE: memberProfile.POST_CODE || '',
          INSURED_CITY_ID: memberProfile.CITY_ID || '',
          INSURED_CITY_ID_NAME: commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || ''),
          INSURED_AREA_ID: memberProfile.AREA_ID || '',
          INSURED_AREA_ID_NAME: commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
          INSURED_ADDRESS: memberProfile.ADDRESS || '',
          POLICYHOLDER_RELATION: InsuredRelation.SameInsured,
          POLICYHOLDER_RELATION_NAME: this.handleGetRelationName(this.state.relationVSysOpts, InsuredRelation.SameInsured)
        };
        activeRelation = InsuredRelation.SameInsured;
      }

      this.setState({
        ...this.props.tempFill.tempFillState as InsureProcessFillState,
        isSelf: isSelf,
        isLoginComplete: this.props.fetchFavoriteComplete,
        activeInsuredNationalityType: activeNationalityType,
        activeRelation: activeRelation,
        blockDomains
      });
    } else if (hasTemp && this.props.tempFill.tempFillFormValue &&
      this.props.tempVehicleOwnerInfo && this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue) {
      const vehicleOwnerInfoFormVal = { ...this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue };
      const fillFormVal = { ...this.props.tempFill.tempFillFormValue };
      const isLoginComplete = this.props.tempFill.tempFillState?.isLoginComplete;
      // console.log('進 2');
      // 1.登入狀態下與被保人相同
      // 2.登入狀態下不與被保人相同
      // 3.未登入狀態
      if (this.props.fetchFavoriteComplete && memberProfile && isSelf) {
        console.log('進2-1');
        this.setState({ hideInsuredID: true, hidePolicyID: true });
        activeNationalityType = memberProfile.NATIONALITY_TYPE;
        activeRelation = InsuredRelation.SameInsured;
        showMemberInfoErrorModal = true;
        samePolicyholder = true;
        formInitialValues = {
          ...this.props.tempFill.tempFillFormValue,
          INSURED_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
          INSURED_MEMBER_ID: memberProfile.MEMBER_ID,
          INSURED_BIRTHDAY: memberProfile.BIRTHDAY,
          INSURED_NAME: memberProfile.NAME,
          INSURED_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
          INSURED_EMAIL: memberProfile.EMAIL_ADDR,
          INSURED_MOBILE: memberProfile.MOBILE,
          INSURED_POST_CODE: memberProfile.POST_CODE || '',
          INSURED_CITY_ID: memberProfile.CITY_ID || '',
          INSURED_CITY_ID_NAME: commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || ''),
          INSURED_AREA_ID: memberProfile.AREA_ID || '',
          INSURED_AREA_ID_NAME: commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
          INSURED_ADDRESS: memberProfile.ADDRESS || '',
          POLICYHOLDER_RELATION: InsuredRelation.SameInsured,
          POLICYHOLDER_RELATION_NAME: this.handleGetRelationName(this.state.relationVSysOpts, InsuredRelation.SameInsured),
          POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
          POLICYHOLDER_MEMBER_ID: memberProfile.MEMBER_ID,
          POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
          POLICYHOLDER_NAME: memberProfile.NAME,
          POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
          POLICYHOLDER_EMAIL: isLoginComplete ? fillFormVal.POLICYHOLDER_EMAIL : memberProfile.EMAIL_ADDR,
          POLICYHOLDER_MOBILE: memberProfile.MOBILE,
          POLICYHOLDER_POST_CODE: isLoginComplete ? fillFormVal.POLICYHOLDER_POST_CODE : memberProfile.POST_CODE || '',
          POLICYHOLDER_CITY_ID: isLoginComplete ? fillFormVal.POLICYHOLDER_CITY_ID : memberProfile.CITY_ID || '',
          POLICYHOLDER_CITY_ID_NAME: isLoginComplete
            ? commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], fillFormVal.POLICYHOLDER_CITY_ID || '')
            : commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || ''),
          POLICYHOLDER_AREA_ID: isLoginComplete ? fillFormVal.POLICYHOLDER_AREA_ID : memberProfile.AREA_ID || '',
          POLICYHOLDER_AREA_ID_NAME: isLoginComplete
            ? commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], fillFormVal.POLICYHOLDER_CITY_ID || '', fillFormVal.POLICYHOLDER_AREA_ID || '')
            : commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
          POLICYHOLDER_ADDRESS: isLoginComplete ? fillFormVal.POLICYHOLDER_ADDRESS : memberProfile.ADDRESS || ''
        };
      } else if (this.props.fetchFavoriteComplete && memberProfile) {
        console.log('進2-2');
        this.setState({ hidePolicyID: true });
        activeNationalityType = vehicleOwnerInfoFormVal.NATIONALITY_TYPE;
        activeRelation = fillFormVal.POLICYHOLDER_RELATION === InsuredRelation.SameInsured
          ? ''
          : fillFormVal.POLICYHOLDER_RELATION;
        showMemberInfoErrorModal = true;
        samePolicyholder = false;
        formInitialValues = {
          ...this.props.tempFill.tempFillFormValue,
          INSURED_NATIONALITY_TYPE: vehicleOwnerInfoFormVal.NATIONALITY_TYPE || '',
          INSURED_MEMBER_ID: vehicleOwnerInfoFormVal.MEMBER_ID || '',
          INSURED_BIRTHDAY: vehicleOwnerInfoFormVal.BIRTHDAY || '',
          POLICYHOLDER_RELATION: activeRelation,
          POLICYHOLDER_RELATION_NAME: this.handleGetRelationName(
            vehicleOwnerInfoFormVal.NATIONALITY_TYPE === NationalType.Legal
              ? this.state.relationLSysOpts
              : this.state.relationVSysOpts
            , activeRelation
          ),
          POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
          POLICYHOLDER_MEMBER_ID: memberProfile.MEMBER_ID,
          POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
          POLICYHOLDER_NAME: memberProfile.NAME,
          POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
          POLICYHOLDER_EMAIL: isLoginComplete ? fillFormVal.POLICYHOLDER_EMAIL : memberProfile.EMAIL_ADDR,
          POLICYHOLDER_MOBILE: memberProfile.MOBILE,
          POLICYHOLDER_POST_CODE: isLoginComplete ? fillFormVal.POLICYHOLDER_POST_CODE : memberProfile.POST_CODE || '',
          POLICYHOLDER_CITY_ID: isLoginComplete ? fillFormVal.POLICYHOLDER_CITY_ID : memberProfile.CITY_ID || '',
          POLICYHOLDER_AREA_ID: isLoginComplete ? fillFormVal.POLICYHOLDER_AREA_ID : memberProfile.AREA_ID || '',
          POLICYHOLDER_CITY_ID_NAME: isLoginComplete
            ? commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], fillFormVal.POLICYHOLDER_CITY_ID || '')
            : commonService.getCityName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || ''),
          POLICYHOLDER_AREA_ID_NAME: isLoginComplete
            ? commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], fillFormVal.POLICYHOLDER_CITY_ID || '', fillFormVal.POLICYHOLDER_AREA_ID || '')
            : commonService.getAreaName(this.props.tempFill.tempFillState?.postcodes || [], memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
          POLICYHOLDER_ADDRESS: isLoginComplete ? fillFormVal.POLICYHOLDER_ADDRESS : memberProfile.ADDRESS || ''
        };
      } else {
        console.log('進2-3');
        activeNationalityType = vehicleOwnerInfoFormVal.NATIONALITY_TYPE;
        activeRelation = fillFormVal.POLICYHOLDER_RELATION === InsuredRelation.SameInsured &&
          vehicleOwnerInfoFormVal.MEMBER_ID !== fillFormVal.POLICYHOLDER_MEMBER_ID
          ? ''
          : fillFormVal.POLICYHOLDER_RELATION;

        formInitialValues = {
          ...this.props.tempFill.tempFillFormValue,
          INSURED_MEMBER_ID: vehicleOwnerInfoFormVal.MEMBER_ID,
          INSURED_NATIONALITY_TYPE: vehicleOwnerInfoFormVal.NATIONALITY_TYPE,
          INSURED_BIRTHDAY: vehicleOwnerInfoFormVal.BIRTHDAY,
          POLICYHOLDER_RELATION: activeRelation,
          POLICYHOLDER_RELATION_NAME: this.handleGetRelationName(
            vehicleOwnerInfoFormVal.NATIONALITY_TYPE === NationalType.Legal
              ? this.state.relationLSysOpts
              : this.state.relationVSysOpts
            , activeRelation
          ),
          POLICYHOLDER_NATIONALITY_TYPE: activeRelation === InsuredRelation.SameInsured
            ? vehicleOwnerInfoFormVal.NATIONALITY_TYPE
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_NATIONALITY_TYPE
              : '',
          POLICYHOLDER_MEMBER_ID: activeRelation === InsuredRelation.SameInsured
            ? vehicleOwnerInfoFormVal.MEMBER_ID
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_MEMBER_ID
              : '',
          POLICYHOLDER_BIRTHDAY: activeRelation === InsuredRelation.SameInsured
            ? vehicleOwnerInfoFormVal.BIRTHDAY
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_BIRTHDAY
              : '',
          POLICYHOLDER_NAME: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_NAME
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_NAME
              : '',
          POLICYHOLDER_MARRIAGE: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_MARRIAGE
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_MARRIAGE
              : '',
          POLICYHOLDER_EMAIL: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_EMAIL
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_EMAIL
              : '',
          POLICYHOLDER_MOBILE: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_MOBILE
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_MOBILE
              : '',
          POLICYHOLDER_POST_CODE: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_POST_CODE
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_POST_CODE
              : '',
          POLICYHOLDER_CITY_ID: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_CITY_ID
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_CITY_ID
              : '',
          POLICYHOLDER_CITY_ID_NAME: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_CITY_ID_NAME
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_CITY_ID_NAME
              : '',
          POLICYHOLDER_AREA_ID: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_AREA_ID
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_AREA_ID
              : '',
          POLICYHOLDER_AREA_ID_NAME: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_AREA_ID_NAME
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_AREA_ID_NAME
              : '',
          POLICYHOLDER_ADDRESS: activeRelation === InsuredRelation.SameInsured
            ? fillFormVal.INSURED_ADDRESS
            : activeRelation
              ? this.props.tempFill.tempFillFormValue.POLICYHOLDER_ADDRESS
              : ''
        };
      }

      this.setState({
        ...this.props.tempFill.tempFillState as InsureProcessFillState,
        activeInsuredNationalityType: activeNationalityType,
        isSelf: isSelf,
        activeRelation: activeRelation,
        blockDomains
      });
    } else {
      // console.log('進3');
      const initSetting = await service.fetchInitFill(this.props.insTypeId as InsType);

      // 帶入車主資料頁資料到被保人
      formInitialValues = {
        ...formInitialValues,
        INSURED_NATIONALITY_TYPE: this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '',
        INSURED_MEMBER_ID: this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.MEMBER_ID || '',
        INSURED_BIRTHDAY: this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.BIRTHDAY || ''
      };

      activeNationalityType = this.props.tempVehicleOwnerInfo.tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '';

      // 有登入帶入到要保人資料
      if (memberProfile) {
        console.log('進3-1');
        this.setState({ hideInsuredID: true, hidePolicyID: true });
        let policyHolderRelation = '';
        showMemberInfoErrorModal = true;
        if (isSelf) {
          samePolicyholder = true;
          activeNationalityType = memberProfile.NATIONALITY_TYPE;
          activeRelation = InsuredRelation.SameInsured;
          policyHolderRelation = InsuredRelation.SameInsured;

          formInitialValues = {
            ...formInitialValues,
            INSURED_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
            INSURED_MEMBER_ID: memberProfile.MEMBER_ID,
            INSURED_BIRTHDAY: memberProfile.BIRTHDAY,
            INSURED_NAME: memberProfile.NAME,
            INSURED_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
            INSURED_EMAIL: memberProfile.EMAIL_ADDR,
            INSURED_MOBILE: memberProfile.MOBILE,
            INSURED_POST_CODE: memberProfile.POST_CODE || '',
            INSURED_CITY_ID: memberProfile.CITY_ID || '',
            INSURED_CITY_ID_NAME: commonService.getCityName(initSetting.postcodes, memberProfile.CITY_ID || ''),
            INSURED_AREA_ID: memberProfile.AREA_ID || '',
            INSURED_AREA_ID_NAME: commonService.getAreaName(initSetting.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
            INSURED_ADDRESS: memberProfile.ADDRESS || ''
          };
        }

        formInitialValues = {
          ...formInitialValues,
          POLICYHOLDER_NATIONALITY_TYPE: memberProfile.NATIONALITY_TYPE,
          POLICYHOLDER_MEMBER_ID: memberProfile.MEMBER_ID,
          POLICYHOLDER_BIRTHDAY: memberProfile.BIRTHDAY,
          POLICYHOLDER_NAME: memberProfile.NAME,
          POLICYHOLDER_MARRIAGE: memberProfile.MARRIAGE || Marriage.Single,
          POLICYHOLDER_EMAIL: memberProfile.EMAIL_ADDR,
          POLICYHOLDER_MOBILE: memberProfile.MOBILE,
          POLICYHOLDER_POST_CODE: memberProfile.POST_CODE || '',
          POLICYHOLDER_CITY_ID: memberProfile.CITY_ID || '',
          POLICYHOLDER_CITY_ID_NAME: commonService.getCityName(initSetting.postcodes, memberProfile.CITY_ID || ''),
          POLICYHOLDER_AREA_ID: memberProfile.AREA_ID || '',
          POLICYHOLDER_AREA_ID_NAME: commonService.getAreaName(initSetting.postcodes, memberProfile.CITY_ID || '', memberProfile.AREA_ID || ''),
          POLICYHOLDER_ADDRESS: memberProfile.ADDRESS || '',
          POLICYHOLDER_RELATION: policyHolderRelation,
          POLICYHOLDER_RELATION_NAME: this.handleGetRelationName(this.state.relationVSysOpts, InsuredRelation.SameInsured),
          DELIVERY: initSetting.policyDeliverySysOpts[0].PARAM_VALUE
        };
      }

      this.setState({
        activeInsuredNationalityType: activeNationalityType,
        activeRelation: activeRelation,
        postcodes: [...initSetting.postcodes],
        emailDomains: [...initSetting.emailDomains],
        policyDeliverySysOpts: [...initSetting.policyDeliverySysOpts],
        relationLSysOpts: [...initSetting.relationLSysOpts],
        relationVSysOpts: [...initSetting.relationVSysOpts],
        marriageSysOpts: [...initSetting.marriageSysOpts],
        polValCodes: [...initSetting.polValCodes],
        isSelf: isSelf,
        isLoginComplete: this.props.fetchFavoriteComplete,
        blockDomains
      });
    }

    if (showMemberInfoErrorModal && commonService.checkMemberInfoError(memberProfile)) {
      const checkfields = samePolicyholder
        ? ['POLICYHOLDER_MOBILE', 'POLICYHOLDER_EMAIL', 'INSURED_MOBILE', 'INSURED_EMAIL']
        : ['POLICYHOLDER_MOBILE', 'POLICYHOLDER_EMAIL'];

      this.props.setMemberInfoErrorModalVisible(true, '', commonService.getCodeMsg(this.props.UICodes, CodeId.W066), [...checkfields]);
    }

    // console.log('InsureProcessFill temp State', JSON.stringify(this.props.tempState));
  }

  componentDidUpdate () {
    /** 抓取電子郵件欄位，限制輸入長度用 */
    const insuredEmailInput = document.getElementById('insured_email') as HTMLInputElement;
    if (insuredEmailInput) {
      insuredEmailInput.setAttribute('maxlength', '50');
      insuredEmailInput.setAttribute('autocomplete', 'off');
    }

    const policyHolderEmailInput = document.getElementById('policy_holder_email') as HTMLInputElement;
    if (policyHolderEmailInput) {
      policyHolderEmailInput.setAttribute('maxlength', '50');
      policyHolderEmailInput.setAttribute('autocomplete', 'off');
    }
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    let formVal = this.formikRef.current.values;
    formVal = {
      ...formVal,
      INSURED_BIRTHDAY: formVal.INSURED_NATIONALITY_TYPE === NationalType.Legal
        ? ''
        : formVal.INSURED_BIRTHDAY,
      INSURED_MARRIAGE: formVal.INSURED_NATIONALITY_TYPE === NationalType.Legal
        ? Marriage.Single
        : formVal.INSURED_MARRIAGE,
      POLICYHOLDER_BIRTHDAY: formVal.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal
        ? ''
        : formVal.POLICYHOLDER_BIRTHDAY,
      POLICYHOLDER_MARRIAGE: formVal.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal
        ? Marriage.Single
        : formVal.POLICYHOLDER_MARRIAGE
    };

    this.props.onUnmount(formVal, this.state);

    this.removeWindowScrollEvent();
    formInitialValues = {
      ...initFormVal
    };
  }

  /**
   * @description 新增 window scroll 事件監聽
   */
  addWindowScrollEvent = () => {
    window.addEventListener('scroll', this.toggleVehicleOwnerInfoFixedVisible, true);
  }

  /**
   * @description 移除 window scroll 事件監聽
   */
  removeWindowScrollEvent = () => {
    window.removeEventListener('scroll', this.toggleVehicleOwnerInfoFixedVisible, false);
  }

  /**
   * @description 視窗滾動至「被保險人資料」區塊時，顯示「車主資料」Fixed 區塊 (Fixed 在 Header 下方)
   */
  toggleVehicleOwnerInfoFixedVisible = () => {
    if (this.insuredInfoRef.current) {
      const headerHeight = document.getElementsByTagName('header')[0].offsetHeight;
      const vehicalInfoOffsetTop = (window.pageYOffset + this.insuredInfoRef.current.getBoundingClientRect().top) - headerHeight;
      const scrollTopPosition = window.pageYOffset;

      this.setState(state => ({
        ...state,
        vehicleOwnerInfoFixedVisible: (scrollTopPosition > vehicalInfoOffsetTop)
      }));
    }
  }

  /**
   * @description 取得與被保人關係名稱
  */
  handleGetRelationName = (relationSysOpts: SysOption[], relationVal: string) => {
    const sysOpt = _.find(relationSysOpts, (sysOpt: SysOption) => sysOpt.PARAM_VALUE === relationVal);
    if (!sysOpt) return '';

    return sysOpt.PARAM_TEXT;
  }

  /** 取得電子信箱常用 Domain Name */
  handleGetDomainSource = (val: string) => {
    const emailDNs: any = new Array(0);
    // 有輸入值，且尚未輸入 @ 呈現常用 Domain Name 選單
    if (val && val.indexOf('@') === -1) {
      _.map(this.state.emailDomains, (emailDomain: EmailDomain) => {
        emailDNs.push({ value: `${val}@${emailDomain.EMAIL_DOMAIN_NAME}` });
      });
    }
    return emailDNs;
  }

  /**
 * @description 檢核帳號是否已存在格式是否正確
 */
  handleValidID = _.debounce(async (val: any, nationalityType: string) => {
    if ((nationalityType === NationalType.National || nationalityType === NationalType.Foreigner) && val.length === 10) {
      const errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);

      this.setState({ policyholderIdErrMsg: errorVal });
    }

    if (nationalityType === NationalType.Legal && val.length === 8) {
      const errorVal = await memberProfileService.validMemberId(val, nationalityType).then((res: any) => res.ID);

      this.setState({ policyholderIdErrMsg: errorVal });
    }
  }, 500);

  /**
   * @description 與被保人關係選單 change 事件
  */
  handleRelationChange = (e: React.ChangeEvent<HTMLSelectElement>, relationVal: string) => {
    if (!this.formikRef || !this.formikRef.current) return;

    if (this.props.fetchFavoriteComplete) {
      this.formikRef.current.handleChange('POLICYHOLDER_RELATION')(e);
      this.setState({ activeRelation: e.currentTarget.value });
      return;
    }

    const setFieldValue = this.formikRef.current.setFieldValue;

    // 關係不為同被保險人，不同步要保人資料，且清除資料
    if (e.currentTarget.value !== InsuredRelation.SameInsured && (relationVal === InsuredRelation.SameInsured || !relationVal) && !this.props.fetchFavoriteComplete) {
      setFieldValue('POLICYHOLDER_NATIONALITY_TYPE', '');
      setFieldValue('POLICYHOLDER_MEMBER_ID', '');
      setFieldValue('POLICYHOLDER_BIRTHDAY', '');
      setFieldValue('POLICYHOLDER_NAME', '');
      setFieldValue('POLICYHOLDER_MARRIAGE', Marriage.Single);
      setFieldValue('POLICYHOLDER_EMAIL', '');
      setFieldValue('POLICYHOLDER_MOBILE', '');
      setFieldValue('POLICYHOLDER_POST_CODE', '');
      setFieldValue('POLICYHOLDER_CITY_ID', '');
      setFieldValue('POLICYHOLDER_AREA_ID', '');
      setFieldValue('POLICYHOLDER_ADDRESS', '');
      setFieldValue('POLICYHOLDER_CITY_ID_NAME', '');
      setFieldValue('POLICYHOLDER_AREA_ID_NAME', '');
      setFieldValue('POLICYHOLDER_JOB_NUMBER', '');

      this.setState({ policyholderIdErrMsg: '', activeRelation: e.currentTarget.value });
      this.formikRef.current.handleChange('POLICYHOLDER_RELATION')(e);
      return;
    }

    if (e.currentTarget.value !== InsuredRelation.SameInsured && relationVal !== InsuredRelation.SameInsured) {
      this.setState({ policyholderIdErrMsg: '', activeRelation: e.currentTarget.value });
      this.formikRef.current.handleChange('POLICYHOLDER_RELATION')(e);
      return;
    }

    const formVal = this.formikRef.current.values as InsureProcessFillFormValue;

    const validIncomplete = this.handleValidInsuredComplete(formVal);

    if (validIncomplete) {
      setFieldValue('POLICYHOLDER_RELATION', '');
      setFieldValue('POLICYHOLDER_RELATION_NAME', '');
      this.setState({ activeRelation: '' });
      return;
    }

    setFieldValue('POLICYHOLDER_NATIONALITY_TYPE', formVal.INSURED_NATIONALITY_TYPE);
    setFieldValue('POLICYHOLDER_MEMBER_ID', formVal.INSURED_MEMBER_ID);
    setFieldValue('POLICYHOLDER_BIRTHDAY', formVal.INSURED_BIRTHDAY);
    setFieldValue('POLICYHOLDER_NAME', formVal.INSURED_NAME);
    setFieldValue('POLICYHOLDER_MARRIAGE', formVal.INSURED_MARRIAGE);
    setFieldValue('POLICYHOLDER_EMAIL', formVal.INSURED_EMAIL);
    setFieldValue('POLICYHOLDER_MOBILE', formVal.INSURED_MOBILE);
    setFieldValue('POLICYHOLDER_POST_CODE', formVal.INSURED_POST_CODE);
    setFieldValue('POLICYHOLDER_CITY_ID', formVal.INSURED_CITY_ID);
    setFieldValue('POLICYHOLDER_AREA_ID', formVal.INSURED_AREA_ID);
    setFieldValue('POLICYHOLDER_ADDRESS', formVal.INSURED_ADDRESS);
    setFieldValue('POLICYHOLDER_CITY_ID_NAME', formVal.INSURED_CITY_ID_NAME);
    setFieldValue('POLICYHOLDER_AREA_ID_NAME', formVal.INSURED_AREA_ID_NAME);
    setFieldValue('POLICYHOLDER_JOB_NUMBER', formVal.INSURED_JOB_NUMBER);
    this.setState({ policyholderIdErrMsg: '', activeRelation: e.currentTarget.value });

    this.formikRef.current.handleChange('POLICYHOLDER_RELATION')(e);
  }

  /**
   * @description 檢核被保人區塊欄位是否都已填寫
  */
  handleValidInsuredComplete = (formVal: InsureProcessFillFormValue) => {
    let incomplete =
      !formVal.INSURED_NATIONALITY_TYPE || !formVal.INSURED_NAME || !formVal.INSURED_MOBILE ||
      !formVal.INSURED_EMAIL || !formVal.INSURED_POST_CODE || !formVal.INSURED_CITY_ID ||
      !formVal.INSURED_AREA_ID || !formVal.INSURED_ADDRESS || !formVal.INSURED_MEMBER_ID;

    if (formVal.INSURED_NATIONALITY_TYPE !== NationalType.Legal) {
      incomplete = incomplete || !formVal.INSURED_BIRTHDAY || !formVal.INSURED_MARRIAGE;
    }

    if (incomplete) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '請先將被保人資料填寫完畢'
      });
    }

    return incomplete;
  }

  /**
   * @description 判斷要保人關係是否同被保人資料
  */
  handleSetPolicyVal = async (fieldName: string, val: any) => {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values as InsureProcessFillFormValue;
    if (formVal.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured) return;

    this.formikRef.current.setFieldValue(fieldName, val);
  }

  /**
   * @description 被保人 email onBlur 事件
  */
  handleInsuredEmailBlur = () => {
    const emailInput = document.getElementById('insured_email') as HTMLInputElement;
    if (!emailInput) return;

    this.handleSetPolicyVal('POLICYHOLDER_EMAIL', emailInput.value);
  }

  /**
   * @description 地址區塊 blur 事件
  */
  handleAddressBlur = () => {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values as InsureProcessFillFormValue;
    if (formVal.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured) return;

    const postCodeInput = document.getElementById('insured-post-code-input') as HTMLInputElement;
    const cityIdSelect = document.getElementById('insured-city-select') as HTMLSelectElement;
    const areaIdSelect = document.getElementById('insured-area-select') as HTMLSelectElement;
    const addressInput = document.getElementById('insured-address-input') as HTMLInputElement;

    if (!postCodeInput || !cityIdSelect || !areaIdSelect || !addressInput) return;

    setTimeout(() => {
      const setFieldValue = this.formikRef.current.setFieldValue;

      setFieldValue('POLICYHOLDER_POST_CODE', postCodeInput.value);
      setFieldValue('POLICYHOLDER_CITY_ID', cityIdSelect.value);
      setFieldValue('POLICYHOLDER_AREA_ID', areaIdSelect.value);
      setFieldValue('POLICYHOLDER_ADDRESS', addressInput.value);
      setFieldValue('POLICYHOLDER_CITY_ID_NAME', cityIdSelect.options[cityIdSelect.selectedIndex].text);
      setFieldValue('POLICYHOLDER_AREA_ID_NAME', areaIdSelect.options[areaIdSelect.selectedIndex].text);
    });
  }

  /**
   * @description 返回上一頁
  */
  handleGoBack = (values: InsureProcessFillFormValue) => {
    const state = {
      ...this.state,
      isLoginComplete: this.props.fetchFavoriteComplete
    };
    this.props.onGoBack(values, state);
  }

  /**
   * @description 表單 Submit 事件
  */
  handleFormSubmit = async (values: InsureProcessFillFormValue) => {
    const selectState = { ...this.props.tempSelect.tempSelectState } as InprocessSelectState;
    const { validVehicleInsRuleRes } = selectState;

    let applyType: string = '';
    if (validVehicleInsRuleRes.FORCE_BCTYPE_C) {
      applyType = ApplyType.WebInsured;
    }

    if (validVehicleInsRuleRes.FORCE_BCTYPE_B) {
      applyType = ApplyType.WebRequire;
    }

    let validApplyTypeRes;
    let loginInfo = false;
    // 商品檢核結果非限網要，呼叫 網要網投判斷
    if (!validVehicleInsRuleRes.FORCE_BCTYPE_B) {
      // 網要網投判斷
      validApplyTypeRes = await this.handleValidApplyType(values);
      if (!validApplyTypeRes) return;

      // 尚未登入，且建議登入提示訊息是否登入
      if (!this.props.fetchFavoriteComplete && validApplyTypeRes.PROMPT_LOGIN) {
        // 則呈現Lightbox提示 是否要登入? ，提供確定、取消供客戶執行
        loginInfo = await sweetAlertService.modal({
          html: `${commonService.getCodeMsg(this.props.UICodes, CodeId.W043)}`,
          showCancelButton: true,
          showCloseButton: true
        }).then(async res => res.value);
      }
    }

    if (loginInfo) {
      this.props.onLogin(values, this.state);
      return;
    }

    // 若商品選擇結果為 網投 (C) 呼叫 網要網投判斷 API 進行比對
    if (applyType === ApplyType.WebInsured && validApplyTypeRes) {
      // 商品選擇頁檢核為網投，但 網要網投判斷結果不為網投，提示訊息，不給繼續
      if (validApplyTypeRes.BC_TYPE !== ApplyType.WebInsured) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          html: commonService.getCodeMsg(this.props.UICodes, CodeId.W031)
        });

        return;
      }
    }

    // 若投保商品都未決定是 網要或網投，呼叫 網要網投判斷 API 取得類型
    if (!applyType && validApplyTypeRes) {
      applyType = validApplyTypeRes.BC_TYPE;
    }

    // 登入狀態下，網要網投判斷結果為 網要時提示訊息
    if (this.props.fetchFavoriteComplete && applyType === ApplyType.WebRequire) {
      sweetAlertService.modal({
        html: commonService.getCodeMsg(this.props.UICodes, CodeId.W011),
        showCloseButton: true
      });
    }

    // 網路要保投保單號
    const serialNo = await this.handleFetchSerialNo(applyType);
    if (!serialNo) return;

    // 手機與電子郵件檢核 (2024/04/02)
    const verifyRes = await this.verifyMailAndMobile(values);
    if (!verifyRes) return;

    // 車險保單共通規則檢核
    const validInsCommonRuleRes = await this.handleValidInsCommonRule(applyType, serialNo, values);
    if (!validInsCommonRuleRes) return;
    const insCommonRuleError = this.handleShowInsCommonErrorByAPI(validInsCommonRuleRes);
    if (insCommonRuleError) return;
    // console.log('validInsCommonRuleRes', validInsCommonRuleRes);

    const newState: InsureProcessFillState = {
      ...this.state,
      applyType: applyType,
      serialNo: serialNo,
      isLoginComplete: this.props.fetchFavoriteComplete,
      promoteLogin: validApplyTypeRes?.PROMPT_LOGIN || false
    };

    const formVal: InsureProcessFillFormValue = {
      ...values,
      INSURED_BIRTHDAY: values.INSURED_NATIONALITY_TYPE === NationalType.Legal
        ? ''
        : values.INSURED_BIRTHDAY,
      INSURED_MARRIAGE: values.INSURED_NATIONALITY_TYPE === NationalType.Legal
        ? Marriage.Single
        : values.INSURED_MARRIAGE,
      POLICYHOLDER_BIRTHDAY: values.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal
        ? ''
        : values.POLICYHOLDER_BIRTHDAY,
      POLICYHOLDER_MARRIAGE: values.POLICYHOLDER_NATIONALITY_TYPE === NationalType.Legal
        ? Marriage.Single
        : values.POLICYHOLDER_MARRIAGE
    };

    this.setState({ ...newState });

    this.props.onFillSubmit(formVal, newState);
  }

  /**
   * @description 網要網投判斷
  */
  handleValidApplyType = async (values: InsureProcessFillFormValue) => {
    const selectFormVal = this.props.tempSelect.tempSelectFormValue as InprocessSelectFormValue;
    const req: CheckVehicleApplyTypeReq = {
      APPLICANT_ID: values.POLICYHOLDER_MEMBER_ID,
      APPLICANT_BIRTHDAY: moment(values.POLICYHOLDER_BIRTHDAY).format('YYYYMMDD'),
      INSURED_ID: values.INSURED_MEMBER_ID,
      INSURED_ID_TYPE: values.INSURED_NATIONALITY_TYPE,
      COMPULSORY_SDATE: selectFormVal.COMPULSORY_INS_EFFECTIVE_DATE ? moment(selectFormVal.COMPULSORY_INS_EFFECTIVE_DATE).format('YYYY-MM-DD HH:mm:ss') : '',
      VOLUNTARY_SDATE: selectFormVal.ARBITRARY_INS_EFFECTIVE_DATE ? moment(selectFormVal.ARBITRARY_INS_EFFECTIVE_DATE).format('YYYY-MM-DD HH:mm:ss') : ''
    };

    return await service.validApplyType(req);
  }

  /**
   * @description 取得網路要保投保單號
  */
  handleFetchSerialNo = async (applyType: string) => {
    const req: VehiclePolicyNoReq = {
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: this.props.tempSelect.tempSelectState?.activeProdId || '',
      SERIAL_TYPE: ApplyNoType.WebRequire,
      BC_TYPE: applyType
    };

    return await service.fetchVehiclePolicyNo(req);
  }

  /**
    * @description 取得有投保的保障內容資料
   */
  handleFetchInsuredPolicys = (policyItemList: PolicyItemListContent[]) => {
    const insuredPolicy = new Array(0);

    _.forEach(policyItemList, (policyItem: PolicyItemListContent) => {
      _.forEach(policyItem.MAIN_ITEMS, (mainItem: any) => {
        if (mainItem.CHECKED) {
          insuredPolicy.push({
            ...mainItem,
            ITEM: mainItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (mainItem.ADDITIONAL_TERM && mainItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(mainItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });

      _.forEach(policyItem.SUB_ITEMS, (subItem: any) => {
        if (subItem.CHECKED) {
          insuredPolicy.push({
            ...subItem,
            ITEM: subItem,
            ITEM_TYPE: policyItem.ITEM_TYPE
          });
        }

        if (subItem.ADDITIONAL_TERM && subItem.ADDITIONAL_TERM.length > 0) {
          _.forEach(subItem.ADDITIONAL_TERM, (additionalTerm: any) => {
            if (additionalTerm.CHECKED) {
              insuredPolicy.push({
                ...additionalTerm,
                ITEM: additionalTerm,
                ITEM_TYPE: policyItem.ITEM_TYPE
              });
            }
          });
        }
      });
    });

    return insuredPolicy;
  }

  /**
   * @description 手機與電子郵件檢核
   * @param values 表單值
   */
  verifyMailAndMobile = async (values: InsureProcessFillFormValue) => {
    const args: InfoCheckmailandmobileReq = {
      CHECKMAILANDMOBILE: [
        // 要保人
        {
          SEQ: '01',
          NAME: values.POLICYHOLDER_NAME,
          MOBILE: values.POLICYHOLDER_MOBILE,
          MAIL: values.POLICYHOLDER_EMAIL
        },
        // 被保人
        {
          SEQ: '02',
          NAME: values.INSURED_NAME,
          MOBILE: values.INSURED_MOBILE,
          MAIL: values.INSURED_EMAIL
        }
      ]
    };
    const response = await apiCommonService.validMailAndMobile(args);
    if (!response) return false;
    if (response && response.CHECKMAILANDMOBILE) {
      if (response.CHECKMAILANDMOBILE.some(it => it.ISSUCCESS !== 'Y')) {
        const errorMsg: string[] = response.CHECKMAILANDMOBILE.filter(it => it.ISSUCCESS !== 'Y').map(it => it.MESSAGE);
        // 呈現多則檢核失敗
        this.props.setRuleValidErrorModalVisible(true, errorMsg);
        return false;
      }
    }
    // 檢核成功
    return true;
  }

  /**
   * @description 車險保單共通規則檢核
  */
  handleValidInsCommonRule = async (applyType: string, serialNo: string, values: InsureProcessFillFormValue) => {
    const { tempVehicleOwnerInfoFormValue } = this.props.tempVehicleOwnerInfo;
    const { tempSelectFormValue } = this.props.tempSelect;
    if (!tempVehicleOwnerInfoFormValue || !tempSelectFormValue) return;

    const insuredPolicys = this.handleFetchInsuredPolicys(tempSelectFormValue.POLICY_ITEM);

    let hasCoVo;

    // 是否包含強制險項目
    const hasCompulsory = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_CI) !== -1;
    if (hasCompulsory) hasCoVo = '1';

    // 是否包含任意險項目
    const hasArbitrary = _.findIndex(insuredPolicys, (insuredPolicy: any) =>
      insuredPolicy.CV_TYPE === VehicleItemType.CV_TYPE_VI) !== -1;

    if (hasArbitrary) hasCoVo = '2';

    if (hasCompulsory && hasArbitrary) hasCoVo = '3';

    // const req: ValidVehicleInsCommonRuleReq = {
    //   INS_TYPE_ID: this.props.insTypeId,
    //   PROD_ID: this.props.tempSelect.tempSelectState?.activeProdId || '',
    //   SPI_ATTACH: '0',
    //   BC_TYPE: applyType,
    //   APPLY_NO: serialNo,
    //   HAS_CO_VO: hasCoVo,
    //   DATA: [
    //     {
    //       ROLE_TYPE: RuleCheckInsuredType.Insured,
    //       ID: values.INSURED_MEMBER_ID,
    //       ID_TYPE: values.INSURED_NATIONALITY_TYPE,
    //       NAME: values.INSURED_NAME,
    //       NATIVE_ID: values.INSURED_NATIONALITY_TYPE,
    //       OCP_TYPE: OccupationIdType.RuleCheckNormal,
    //       FEE: commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI)
    //     },
    //     {
    //       ROLE_TYPE: RuleCheckInsuredType.Applicant,
    //       ID: values.POLICYHOLDER_MEMBER_ID,
    //       ID_TYPE: values.POLICYHOLDER_NATIONALITY_TYPE,
    //       NAME: values.POLICYHOLDER_NAME,
    //       NATIVE_ID: values.POLICYHOLDER_NATIONALITY_TYPE,
    //       OCP_TYPE: OccupationIdType.RuleCheckNormal,
    //       FEE: commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI)
    //     }
    //   ]
    // };
    // //  console.log('validInsCommonRule', JSON.stringify(req));
    // return await service.validInsCommonRule(req);

    const args: ValidVehicleBlackListReq = {
      INS_TYPE_ID: this.props.insTypeId,
      PROD_ID: this.props.tempSelect.tempSelectState?.activeProdId || '',
      BC_TYPE: applyType,
      APPLY_NO: serialNo,
      HAS_CO_VO: hasCoVo,
      LICENSE: `${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue.LICENSE_PLATE_NUMBER_BACK}`,
      ENGINE_ID: tempSelectFormValue.ENGINE_NUMBER,
      DATA: [
        {
          ROLE_TYPE: RuleCheckInsuredType.Insured,
          ID: values.INSURED_MEMBER_ID,
          ID_TYPE: values.INSURED_NATIONALITY_TYPE,
          NAME: values.INSURED_NAME,
          NATIVE_ID: values.INSURED_NATIONALITY_TYPE,
          OCP_TYPE: OccupationIdType.RuleCheckNormal,
          FEE: commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI),
          JOB_NUMBER: values.INSURED_JOB_NUMBER
        },
        {
          ROLE_TYPE: RuleCheckInsuredType.Applicant,
          ID: values.POLICYHOLDER_MEMBER_ID,
          ID_TYPE: values.POLICYHOLDER_NATIONALITY_TYPE,
          NAME: values.POLICYHOLDER_NAME,
          NATIVE_ID: values.POLICYHOLDER_NATIONALITY_TYPE,
          OCP_TYPE: OccupationIdType.RuleCheckNormal,
          FEE: commonService.getVehiclePrenium(this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUM, this.props.tempSelect.tempSelectState?.evalCarRes.SUMPREMIUM[1].SUMPREMIUMCI),
          JOB_NUMBER: values.POLICYHOLDER_JOB_NUMBER
        }
      ],
      IPOLICY: this.props.tempVehicleInfo.tempVehicleInfoState?.renewVehicle?.Ipolicy ?? null
    };
    return await service.validVehicleBlackList(args);
  }

  /**
   * @description 判斷車險保單共通規則檢核結果是否顯示錯誤訊息 (顯示由 API 回傳的錯誤訊息)
   */
  handleShowInsCommonErrorByAPI = (insCommonRuleRes: ValidVehicleBlackListRes) => {
    if (insCommonRuleRes.ERROR_MSG.length > 0) {
      this.props.setRuleValidErrorModalVisible(true, insCommonRuleRes.ERROR_MSG);
    }
    return insCommonRuleRes.ERROR_MSG.length > 0;
  };

  /**
   * @description 判斷車險保單共通規則檢核結果是否顯示錯誤訊息
  */
  // handleShowInsCommonError = (insCommonRuleRes: ValidVehicleBlackListRes) => {
  //   // 錯誤筆數為 0 ，表示無錯誤
  //   if (!insCommonRuleRes.FAIL) return false;

  //   // 風險過高的投保人姓名集合
  //   const riskErrorNames = new Array(0);
  //   // 洗錢黑名黑名單的投保人姓名集合
  //   const launderErrorNames = new Array(0);

  //   _.forEach(insCommonRuleRes.COMMONCHECK, (checkContent: VehicleInsCommonRuleCheckContent) => {
  //     if (checkContent.RISKSCORE > 35) {
  //       riskErrorNames.push(checkContent.NAME);
  //     }

  //     if (checkContent.MONEY_LAUNDER_CORE || checkContent.MONEY_LAUNDERING === '0000') {
  //       launderErrorNames.push(checkContent.NAME);
  //     }
  //   });

  //   const errorMsgs = new Array(0);
  //   if (riskErrorNames.length > 0) {
  //     const errorName = riskErrorNames.join(',');
  //     const polValMsg = commonService.getCodeMsg(this.state.polValCodes, CodeId.PV01).replace('{#被保人姓名}', errorName);
  //     errorMsgs.push(polValMsg);
  //   }

  //   if (launderErrorNames.length > 0) {
  //     const errorName = launderErrorNames.join(',');
  //     const polValMsg = commonService.getCodeMsg(this.state.polValCodes, CodeId.PV02).replace('{#被保人姓名}', errorName);

  //     errorMsgs.push(polValMsg);
  //   }

  //   if (errorMsgs.length > 0) {
  //     this.props.setRuleValidErrorModalVisible(true, errorMsgs);
  //   }

  //   return errorMsgs.length > 0;
  // }

  handleViewToggle = (type: string) => {
    switch (type) {
      case toggle.insured: {
        this.setState({ hideInsuredID: !this.state.hideInsuredID });
        break;
      }
      case toggle.policy: {
        this.setState({ hidePolicyID: !this.state.hidePolicyID });
        break;
      }
    }
  };

  render () {
    const { tempVehicleOwnerInfo, tempVehicleInfo } = this.props;
    const { tempVehicleOwnerInfoFormValue } = tempVehicleOwnerInfo;
    const { tempVehicleInfoFormValue } = tempVehicleInfo;

    // #region 建立身份別區塊

    let insuredNationalityArea: any;
    let policyHolderNationalityArea: any;
    if (this.props.nationalityVSysOpts && this.props.nationalityVSysOpts.length > 0 && this.formikRef && this.formikRef.current) {
      insuredNationalityArea = _.map(this.props.nationalityVSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`insured-native-radio-${sysOpt.PARAM_VALUE}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="INSURED_NATIONALITY_TYPE"
                  id={`insured-native-radio-${sysOpt.PARAM_VALUE}`}
                  value={sysOpt.PARAM_VALUE}
                  disabled
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    this.setState({ activeInsuredNationalityType: sysOpt.PARAM_VALUE });
                    this.handleSetPolicyVal('POLICYHOLDER_NATIONALITY_TYPE', sysOpt.PARAM_VALUE);
                  }}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });

      const formVal = this.formikRef.current.values as InsureProcessFillFormValue;
      policyHolderNationalityArea = _.map(this.props.nationalityVSysOpts, (sysOpt: SysOption, index: number) => {
        if (this.state.activeInsuredNationalityType && this.state.activeInsuredNationalityType !== NationalType.Legal && sysOpt.PARAM_VALUE === NationalType.Legal) return;
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`policy-native-radio-${sysOpt.PARAM_VALUE}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="POLICYHOLDER_NATIONALITY_TYPE"
                  id={`policy-native-radio-${sysOpt.PARAM_VALUE}`}
                  value={sysOpt.PARAM_VALUE}
                  disabled={this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete}
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                    if (formVal.POLICYHOLDER_NATIONALITY_TYPE !== e.currentTarget.value) {
                      this.handleValidID(formVal.POLICYHOLDER_MEMBER_ID, e.currentTarget.value);
                    }
                  }}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 建立保單交付方式區塊

    let policyDeliveryArea: JSX.Element[];
    if (this.state.policyDeliverySysOpts && this.state.policyDeliverySysOpts.length > 0) {
      policyDeliveryArea = _.map(this.state.policyDeliverySysOpts, (sysopt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`electronic-delivery-radio${index}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="DELIVERY"
                  id={`electronic-delivery-radio${index}`}
                  value={sysopt.PARAM_VALUE}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysopt.PARAM_TEXT}</span>
            </label>
            {
              sysopt.PARAM_VALUE === PolicyDelivery.Electric ? <a className="element__link" href={RouterSettings.MemberCenter.ElectronicPolicy} rel="noopener noreferrer" target="_blank">(說明)</a> : null
            }
          </div>
        );
      });
    }

    // #endregion

    // #region 建立婚姻狀況區塊

    const handleCreateMarriageArea = (fieldName: string) => {
      return _.map(this.state.marriageSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`${fieldName}-marriage-radio-${sysOpt.PARAM_ID}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name={fieldName}
                  disabled={(fieldName === 'POLICYHOLDER_MARRIAGE' && (this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete)) || (this.state.isSelf && this.props.fetchFavoriteComplete)}
                  id={`${fieldName}-marriage-radio-${sysOpt.PARAM_ID}`}
                  value={sysOpt.PARAM_VALUE}
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => this.handleSetPolicyVal('POLICYHOLDER_MARRIAGE', e.currentTarget.value)}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    };

    // #endregion

    // #region 建立與被保人關係下拉選單

    let relationOpts: any;
    switch (this.state.activeInsuredNationalityType) {
      case NationalType.National:
      case NationalType.Foreigner:
      default:
        relationOpts = _.map(this.state.relationVSysOpts, (sysOpt: SysOption, index: number) => {
          // 若有登入、且身份為同一人，移除同被保險人項目
          if (this.state.isLoginComplete &&
            this.props.fetchFavoriteComplete &&
            !this.state.isSelf &&
            sysOpt.PARAM_VALUE === InsuredRelation.SameInsured
          ) {
            return;
          }
          return <option value={sysOpt.PARAM_VALUE} key={index}>{sysOpt.PARAM_TEXT}</option>;
        });
        break;
      case NationalType.Legal:
        relationOpts = _.map(this.state.relationLSysOpts, (sysOpt: SysOption, index: number) => {
          // 若有登入、且身份為同一人，移除同被保險人項目
          if (this.state.isLoginComplete &&
            this.props.fetchFavoriteComplete &&
            !this.state.isSelf &&
            sysOpt.PARAM_VALUE === InsuredRelation.SameInsured
          ) {
            return;
          }
          return <option value={sysOpt.PARAM_VALUE} key={index}>{sysOpt.PARAM_TEXT}</option>;
        });
        break;
    }

    // #endregion

    /**
     * @description 取得 ID 類別對應的顯示名稱
    */
    const handleGetMemberIdType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.Foreigner:
          return '居留證號';
        case NationalType.Legal:
          return '統一編號';
        case NationalType.National:
        default:
          return '身份證字號';
      }
    };

    /**
     * @description 取得生日 類別對應的顯示名稱
    */
    const handleGetBirthdayType = (nationalityType: string) => {
      switch (nationalityType) {
        case NationalType.National:
        case NationalType.Foreigner:
        default:
          return '生日';
        case NationalType.Legal:
          return '公司登記日期';
      }
    };

    /**
     * @description 處理職業類別資料同步
     */
    const handleSyncJobNumber = (event: React.ChangeEvent<HTMLSelectElement>) => {
      const formVal = this.formikRef.current.values as InsureProcessFillFormValue;
      if (formVal.POLICYHOLDER_RELATION === InsuredRelation.SameInsured) {
        this.formikRef.current.setFieldValue('POLICYHOLDER_JOB_NUMBER', event.target.value);
      }
      this.formikRef.current.handleChange('INSURED_JOB_NUMBER')(event);
    };

    return (
      <div className="insure-process-fill">
        <Formik
          initialValues={formInitialValues}
          validationSchema={this.formValidationSchema}
          onSubmit={this.handleFormSubmit}
          enableReinitialize
          innerRef={this.formikRef}
        >
          {
            ({ errors, touched, values, handleBlur, handleChange, setFieldValue }) => (
              <Form>
                <div className="insure-process-fill__content">
                  {/* 投保資訊 (Fixed) */}
                  <div className={`insurance-info-fixed ${this.state.vehicleOwnerInfoFixedVisible ? ' insurance-info-fixed--active' : ''}`}>
                    <div className="template-container">
                      <div className="template-content">
                        <div className="element__list-group">
                          <div className="element__list-group-title">{`${handleGetMemberIdType(tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '')}*`}</div>
                          <div className="element__list-group-content">{tempVehicleOwnerInfoFormValue ? commonService.hiddenStringLastCharacter(tempVehicleOwnerInfoFormValue.MEMBER_ID, 5) : null}</div>
                        </div>
                        {
                          tempVehicleOwnerInfoFormValue && tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE && tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE !== NationalType.Legal && (
                            <div className="element__list-group">
                              <div className="element__list-group-title">{`${handleGetBirthdayType(tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE || '')}`}</div>
                              <div className="element__list-group-content">{moment(tempVehicleOwnerInfoFormValue?.BIRTHDAY).format('YYYY/MM/DD')}</div>
                            </div>
                          )
                        }
                        <div className="element__list-group">
                          <div className="element__list-group-title">車牌號碼</div>
                          <div className="element__list-group-content">{`${tempVehicleOwnerInfoFormValue?.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue?.LICENSE_PLATE_NUMBER_BACK}`}</div>
                        </div>
                        <div className="element__list-group">
                          <div className="element__list-group-title">廠牌</div>
                          <div className="element__list-group-content">{tempVehicleInfoFormValue?.VEHICAL_MAKER}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 投保資訊 */}
                  <div className="insurance-info">
                    <div className="insurance-info__container">
                      <div className="element__list-group">
                        <div className="element__list-group-title">{`${handleGetMemberIdType(tempVehicleOwnerInfoFormValue?.NATIONALITY_TYPE || '')}*`}</div>
                        <div className="element__list-group-content">{tempVehicleOwnerInfoFormValue ? commonService.hiddenStringLastCharacter(tempVehicleOwnerInfoFormValue.MEMBER_ID, 5) : null}</div>
                      </div>
                      {
                        tempVehicleOwnerInfoFormValue && tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE && tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE !== NationalType.Legal && (
                          <div className="element__list-group">
                            <div className="element__list-group-title">{`${handleGetBirthdayType(tempVehicleOwnerInfoFormValue.NATIONALITY_TYPE || '')}`}</div>
                            <div className="element__list-group-content">{moment(tempVehicleOwnerInfoFormValue?.BIRTHDAY).format('YYYY/MM/DD')}</div>
                          </div>
                        )
                      }
                      <div className="element__list-group">
                        <div className="element__list-group-title">車牌號碼</div>
                        <div className="element__list-group-content">{`${tempVehicleOwnerInfoFormValue?.LICENSE_PLATE_NUMBER_FRONT}-${tempVehicleOwnerInfoFormValue?.LICENSE_PLATE_NUMBER_BACK}`}</div>
                      </div>
                      <div className="element__list-group">
                        <div className="element__list-group-title">廠牌</div>
                        <div className="element__list-group-content">{tempVehicleInfoFormValue?.VEHICAL_MAKER}</div>
                      </div>
                    </div>
                  </div>
                  {/* 被保險人資料 */}
                  <div className="insured-info" ref={this.insuredInfoRef}>
                    <div className="insured-info__title">
                      <span>被保險人資料</span>
                      <span>(與行照上車主相同)</span>
                    </div>
                    <div className="insured-info__content">
                      <div className="insured-info__form">
                        <div className="element__form-table">
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 身份別 */}
                              <div className={'element__form-group' + (errors.INSURED_NATIONALITY_TYPE && touched.INSURED_NATIONALITY_TYPE ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">證件類別*</div>
                                <div className="element__form-group-content">
                                  {insuredNationalityArea}
                                </div>
                                <div className="element__error-message">
                                  <ErrorMessage name="INSURED_NATIONALITY_TYPE" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 身份證字號 */}
                              <div className={'element__form-group' + (errors.INSURED_MEMBER_ID && touched.INSURED_MEMBER_ID ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">{`${handleGetMemberIdType(this.state.activeInsuredNationalityType)}*`}</div>
                                {this.state.hideInsuredID
                                  ? <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.INSURED_MEMBER_ID, 5)} disabled readOnly />
                                  : (
                                    <Field
                                      type="text"
                                      name="INSURED_MEMBER_ID"
                                      className="element__input"
                                      autoComplete="off"
                                      maxLength={10}
                                      disabled
                                    // validate={(val:any) => this.handleValidID(val, values.INSURED_NATIONALITY_TYPE, setFieldValue, 'INSURED_MEMBER_ID_ERROR', values.INSURED_MEMBER_ID_ERROR)}
                                    //  onBlur={(e:React.ChangeEvent<HTMLInputElement>) => {
                                    //    handleBlur(e);
                                    //    setFieldValue('INSURED_MEMBER_ID_ERROR', true);
                                    //    this.handleSetPolicyVal('POLICYHOLDER_MEMBER_ID', e.currentTarget.value);
                                    //  }}
                                    //  onChange={(e:React.ChangeEvent<HTMLInputElement>) => {
                                    //    handleChange(e);
                                    //    const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;
                                    //    setFieldValue('INSURED_MEMBER_ID', val);
                                    //  }}
                                    />)}
                                <button type="button" className="element__view-btn" onClick={() => this.handleViewToggle(toggle.insured)}>
                                  {this.state.hideInsuredID ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                                </button>
                                <div className="element__error-message">
                                  <ErrorMessage name="INSURED_MEMBER_ID" />
                                </div>
                              </div>
                            </div>
                            {/* 生日 */}
                            <div className="element__form-table-td">
                              {
                                this.state.activeInsuredNationalityType !== NationalType.Legal && (
                                  <div className={'element__form-group' + (errors.INSURED_BIRTHDAY && touched.INSURED_BIRTHDAY ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">{`${handleGetBirthdayType(this.state.activeInsuredNationalityType)}*`}<span className="ant-picker-exam-info">範例： 20200101</span></div>
                                    <DatePicker
                                      name="INSURED_BIRTHDAY"
                                      className="element__input"
                                      format="YYYYMMDD"
                                      showToday={false}
                                      disabled
                                      disabledDate={(current: any) => {
                                        // 被保人生日
                                        return current && (current > moment().add(-1, 'd') || current < moment('1911/01/01'));
                                        // return current && (current > moment(new Date()) || current < moment('1911/01/01'));
                                      }}
                                      onChange={(val: any) => this.handleSetPolicyVal('POLICYHOLDER_BIRTHDAY', val)}
                                    />
                                    <div className="element__error-message">
                                      <ErrorMessage name="INSURED_BIRTHDAY" />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 被保人姓名 */}
                              <div className={'element__form-group' + (errors.INSURED_NAME && touched.INSURED_NAME ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">被保險人姓名*</div>
                                <Field
                                  type="text"
                                  name="INSURED_NAME"
                                  data-fieldname="INSURED_NAME"
                                  tabIndex={1}
                                  className="element__input"
                                  autoComplete="off"
                                  maxLength={200}
                                  disabled={this.state.isSelf && this.props.fetchFavoriteComplete}
                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleBlur(e);
                                    this.handleSetPolicyVal('POLICYHOLDER_NAME', e.currentTarget.value);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="INSURED_NAME" />
                                </div>
                              </div>
                            </div>
                            {
                              this.state.activeInsuredNationalityType !== NationalType.Legal && (
                                <div className="element__form-table-td">
                                  {/* 婚姻狀況 */}
                                  <div className="element__form-group">
                                    <div className="element__form-group-title">婚姻狀況</div>
                                    <div className="element__form-group-content">
                                      {
                                        handleCreateMarriageArea('INSURED_MARRIAGE')
                                      }
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 電子信箱 */}
                              <div className={'element__form-group' + (errors.INSURED_EMAIL && touched.INSURED_EMAIL ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">電子信箱*</div>
                                <AutoComplete
                                  name="INSURED_EMAIL"
                                  tabIndex={2}
                                  style={{ outline: 'none' }}
                                  data-fieldname="INSURED_EMAIL"
                                  id="insured_email"
                                  className="element__antd-input"
                                  placeholder="請輸入電子信箱"
                                  disabled={this.state.isSelf && this.props.fetchFavoriteComplete}
                                  options={this.handleGetDomainSource(values.INSURED_EMAIL)}
                                  onBlur={this.handleInsuredEmailBlur}
                                  //  validate={(val:any) => {
                                  //    if (!val && !values.INSURED_MOBILE) return '電子信箱與手機號碼至少擇一填寫';

                                //    return '';
                                //  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="INSURED_EMAIL" />
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-td">
                              {/* 手機號碼 */}
                              <div className={'element__form-group' + (errors.INSURED_MOBILE && touched.INSURED_MOBILE ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">手機號碼*</div>
                                <Field
                                  component={InputWithRegex}
                                  name="INSURED_MOBILE"
                                  data-fieldname="INSURED_MOBILE"
                                  tabIndex={3}
                                  className="element__input"
                                  autoComplete="off"
                                  maxLength={10}
                                  disabled={this.state.isSelf && this.props.fetchFavoriteComplete}
                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleBlur(e);
                                    this.handleSetPolicyVal('POLICYHOLDER_MOBILE', e.currentTarget.value);
                                  }}
                                  //  validate={(val:any) => {
                                  //    if (!val && !values.INSURED_EMAIL) return '電子信箱與手機號碼至少擇一填寫';

                                //    return '';
                                //  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="INSURED_MOBILE" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 通訊地址 */}
                              <div onBlur={this.handleAddressBlur} className={'element__form-group' + ((errors.INSURED_POST_CODE && touched.INSURED_POST_CODE) || (errors.INSURED_ADDRESS && touched.INSURED_ADDRESS) || (errors.INSURED_CITY_ID && touched.INSURED_CITY_ID) || (errors.INSURED_AREA_ID && touched.INSURED_AREA_ID) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">通訊地址*</div>
                                <div className="element__form-group-content">
                                  <AddressComponent
                                    postCodeName="INSURED_POST_CODE"
                                    postCodeId="insured-post-code-input"
                                    postCodeIdTabIndex={4}
                                    cityIdName="INSURED_CITY_ID"
                                    cityId="insured-city-select"
                                    cityIdVal={values.INSURED_CITY_ID}
                                    cityIdText="INSURED_CITY_ID_NAME"
                                    cityIdTabIndex={5}
                                    areaIdName="INSURED_AREA_ID"
                                    areaId="insured-area-select"
                                    areaNameVal={values.INSURED_AREA_ID_NAME}
                                    areaIdText="INSURED_AREA_ID_NAME"
                                    areaIdTabIndex={6}
                                    addressName="INSURED_ADDRESS"
                                    addressId="insured-address-input"
                                    addressIdTabIndex={7}
                                    postcodes={this.state.postcodes}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    disabled={this.state.isSelf && this.props.fetchFavoriteComplete}
                                  />
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.INSURED_POST_CODE
                                      ? <ErrorMessage name="INSURED_POST_CODE" />
                                      : errors.INSURED_CITY_ID
                                        ? <ErrorMessage name="INSURED_CITY_ID" />
                                        : errors.INSURED_AREA_ID
                                          ? <ErrorMessage name="INSURED_AREA_ID" />
                                          : errors.INSURED_ADDRESS
                                            ? <ErrorMessage name="INSURED_ADDRESS" />
                                            : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {values.INSURED_NATIONALITY_TYPE !== NationalType.Legal ? (
                                <>
                                  {/* 職業類別 */}
                                  <div className={'element__form-group' + (errors.INSURED_JOB_NUMBER && touched.INSURED_JOB_NUMBER ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">職業類別*</div>
                                    <Field
                                      as="select"
                                      name="INSURED_JOB_NUMBER"
                                      data-fieldname="INSURED_JOB_NUMBER"
                                      tabIndex={8}
                                      className="element__select"
                                      autoComplete="off"
                                      onChange={handleSyncJobNumber}
                                    >
                                      <option value="">請選擇</option>
                                      <option value="1" title="政府機關公務人員 (不含國營事業)">政府機關公務人員 (不含國營事業)</option>
                                      <option value="2" title="本國學生">本國學生</option>
                                      <option value="3" title="一般職業人員 (不含本欄其他列舉職業人員)">一般職業人員 (不含本欄其他列舉職業人員)</option>
                                      <option value="5" title="高風險之行職業宜參考國家洗錢審查及資武擴風險評估報告所列之高及非常高行業，2024年國家洗錢資恐及資武擴風險評估報告所列高及非常高行業類別如下：國際金融業務分行(OBU)、提供虛擬資產服務之事業或人員、本國銀行、國際證券業務分公司(OSU)、外國銀行在臺分行、國際保險業務分公司(OIU)、證券商、銀樓業、辦理儲金匯兌之郵政機構、人壽保險公司、會計師、律師、提供第三方支付服務之事業或人員、不動產經紀業、農業金融機構(含全國農業金庫、農會信用部及漁會信用部)。">高風險職業</option>
                                    </Field>
                                    <div className="element__error-message">
                                      <ErrorMessage name="INSURED_JOB_NUMBER" />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {/* 現金密集型行業 */}
                                  <div className={'element__form-group' + (errors.INSURED_JOB_NUMBER && touched.INSURED_JOB_NUMBER ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">現金密集型行業*</div>
                                    <Field
                                      as="select"
                                      name="INSURED_JOB_NUMBER"
                                      data-fieldname="INSURED_JOB_NUMBER"
                                      tabIndex={8}
                                      className="element__select"
                                      autoComplete="off"
                                    >
                                      <option value="">請選擇</option>
                                      <option value="1" title="國營事業">國營事業</option>
                                      <option value="2" title="本國金融業 (銀行、證券、期貨、投信、保險)">本國金融業 (銀行、證券、期貨、投信、保險)</option>
                                      <option value="3" title="一般公司">一般公司</option>
                                      <option value="4" title="租賃公司">租賃公司</option>
                                      <option value="5" title="藝術品收藏、骨董、拍賣、博奕、珠寶及貴金屬、典當、軍火、融資、基金會、協會、寺廟、匯款、外幣兌換、大使館、辦事處、虛擬貨幣交易">高風險行業</option>
                                    </Field>
                                    <div className="element__error-message">
                                      <ErrorMessage name="INSURED_JOB_NUMBER" />
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 要保人資料 */}
                  <div className="policyholder-info">
                    <div className="policyholder-info__title">要保人資料</div>
                    <div className="policyholder-info__content">
                      <div className="policyholder-info__form">
                        <div className="element__form-table">
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 與被保險人關係 */}
                              <div className={'element__form-group' + (errors.POLICYHOLDER_RELATION && touched.POLICYHOLDER_RELATION ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">與被保險人關係*</div>
                                <Field
                                  as="select"
                                  name="POLICYHOLDER_RELATION"
                                  data-fieldname="POLICYHOLDER_RELATION"
                                  tabIndex={8}
                                  className="element__select"
                                  disabled={this.state.activeRelation === InsuredRelation.SameInsured && this.props.fetchFavoriteComplete}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    commonService.setSelectOptName(setFieldValue, 'POLICYHOLDER_RELATION_NAME', e.currentTarget.selectedOptions.item(0)?.text);
                                    this.handleRelationChange(e, values.POLICYHOLDER_RELATION);
                                  }}
                                >
                                  <option value="">請選擇</option>
                                  {relationOpts}
                                </Field>
                                <div className="element__error-message">
                                  <ErrorMessage name="POLICYHOLDER_RELATION" />
                                </div>
                              </div>
                            </div>
                            {
                              process.env.REACT_APP_MODE !== 'prod' && this.props.fetchFavoriteComplete && (
                                <div className="element__form-table-td update-checkbox" style={{ display: 'none' }}>
                                  <div className="element__checkbox-group">
                                    <label htmlFor="update-info-checkbox">
                                      <div className="element__checkbox">
                                        <Field
                                          type="checkbox"
                                          name="UPDATE_INFO_CHECKED"
                                          id="update-info-checkbox"
                                        />
                                        <div className="element__checkbox-btn" />
                                      </div>
                                      <span>同步更新至會員資料</span>
                                    </label>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 身份別 */}
                              {
                                values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && (
                                  <div className={'element__form-group' + (errors.POLICYHOLDER_NATIONALITY_TYPE && touched.POLICYHOLDER_NATIONALITY_TYPE ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">證件類別*</div>
                                    <div
                                      className="element__form-group-content"
                                      tabIndex={9}
                                      style={{ outline: 'none' }}
                                      data-fieldname="POLICYHOLDER_NATIONALITY_TYPE"
                                    >
                                      {policyHolderNationalityArea}
                                    </div>
                                    <div className="element__error-message">
                                      <ErrorMessage name="POLICYHOLDER_NATIONALITY_TYPE" />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 身份證字號 */}
                              {
                                values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && (
                                  <div className={'element__form-group' + (errors.POLICYHOLDER_MEMBER_ID && touched.POLICYHOLDER_MEMBER_ID ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">{`${handleGetMemberIdType(values.POLICYHOLDER_NATIONALITY_TYPE)}*`}</div>
                                    {this.state.hidePolicyID
                                      ? <input type="text" className="element__input" value={commonService.hiddenStringLastCharacter(values.POLICYHOLDER_MEMBER_ID, 5)} disabled readOnly />
                                      : (
                                        <Field
                                          type="text"
                                          name="POLICYHOLDER_MEMBER_ID"
                                          data-fieldname="POLICYHOLDER_MEMBER_ID"
                                          tabIndex={10}
                                          className="element__input"
                                          autoComplete="off"
                                          maxLength={10}
                                          disabled={this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete}
                                          validate={() => this.state.policyholderIdErrMsg}
                                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            handleChange(e);
                                            const val = e.currentTarget.value ? e.currentTarget.value.toUpperCase() : e.currentTarget.value;

                                            if (values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && val === values.INSURED_MEMBER_ID) {
                                              sweetAlertService.modal({
                                                icon: SweetAlertIcon.Info,
                                                html: commonService.getCodeMsg(this.props.UICodes, CodeId.W055)
                                              });
                                            }
                                            setFieldValue('POLICYHOLDER_MEMBER_ID', val);
                                            this.handleValidID(val, values.POLICYHOLDER_NATIONALITY_TYPE);
                                          }}
                                        />
                                      )}
                                    <button type="button" className="element__view-btn" onClick={() => this.handleViewToggle(toggle.policy)}>
                                      {this.state.hidePolicyID ? <i className="fas fa-eye-slash" /> : <i className="fas fa-eye" />}
                                    </button>
                                    <div className="element__error-message">
                                      <ErrorMessage name="POLICYHOLDER_MEMBER_ID" />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                            {/* 生日 */}
                            <div className="element__form-table-td">
                              {
                                values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && values.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                  <div className={'element__form-group' + (errors.POLICYHOLDER_BIRTHDAY && touched.POLICYHOLDER_BIRTHDAY ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">{`${handleGetBirthdayType(values.POLICYHOLDER_NATIONALITY_TYPE)}*`}<span className="ant-picker-exam-info">範例： 20200101</span></div>
                                    <DatePicker
                                      name="POLICYHOLDER_BIRTHDAY"
                                      data-fieldname="POLICYHOLDER_BIRTHDAY"
                                      tabIndex={11}
                                      className="element__input"
                                      format="YYYYMMDD"
                                      showToday={false}
                                      disabled={this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete}
                                      disabledDate={(current: any) => {
                                        // 要保人生日
                                        return current && (current > moment().add(-18, 'y') || current < moment('1911/01/01'));
                                        // return current && (current > moment(validBirthDay) || current < moment('1911/01/01'));
                                      }}
                                      // defaultPickerValue={moment(validBirthDay)}
                                      defaultPickerValue={moment().add(-18, 'y')}
                                    />
                                    <div className="element__error-message">
                                      <ErrorMessage name="POLICYHOLDER_BIRTHDAY" />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 要保人姓名 */}
                              {
                                values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && (
                                  <div className={'element__form-group' + (errors.POLICYHOLDER_NAME && touched.POLICYHOLDER_NAME ? ' element__form-group--invalid' : '')}>
                                    <div className="element__form-group-title">要保人姓名*</div>
                                    <Field
                                      type="text"
                                      name="POLICYHOLDER_NAME"
                                      data-fieldname="POLICYHOLDER_NAME"
                                      tabIndex={12}
                                      disabled={this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete}
                                      className="element__input"
                                      autoComplete="off"
                                      maxLength={200}
                                    />
                                    <div className="element__error-message">
                                      <ErrorMessage name="POLICYHOLDER_NAME" />
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                            {
                              values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && values.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal && (
                                <div className="element__form-table-td">
                                  {/* 婚姻狀況 */}
                                  <div className="element__form-group">
                                    <div className="element__form-group-title">婚姻狀況</div>
                                    <div className="element__form-group-content">
                                      {
                                        handleCreateMarriageArea('POLICYHOLDER_MARRIAGE')
                                      }
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 電子信箱 */}
                              <div className={'element__form-group' + (errors.POLICYHOLDER_EMAIL && touched.POLICYHOLDER_EMAIL ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">電子信箱*</div>
                                <AutoComplete
                                  name="POLICYHOLDER_EMAIL"
                                  tabIndex={13}
                                  style={{ outline: 'none' }}
                                  data-fieldname="POLICYHOLDER_EMAIL"
                                  id="policy_holder_email"
                                  className="element__antd-input"
                                  placeholder="請輸入電子信箱"
                                  disabled={this.state.activeRelation === InsuredRelation.SameInsured && !this.props.fetchFavoriteComplete}
                                  options={this.handleGetDomainSource(values.POLICYHOLDER_EMAIL)}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="POLICYHOLDER_EMAIL" />
                                </div>
                              </div>
                            </div>
                            <div className="element__form-table-td">
                              {/* 手機號碼 */}
                              <div className={'element__form-group' + (errors.POLICYHOLDER_MOBILE && touched.POLICYHOLDER_MOBILE ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">手機號碼*</div>
                                <Field
                                  component={InputWithRegex}
                                  name="POLICYHOLDER_MOBILE"
                                  data-fieldname="POLICYHOLDER_MOBILE"
                                  tabIndex={14}
                                  className="element__input"
                                  autoComplete="off"
                                  maxLength={10}
                                  disabled={this.state.activeRelation === InsuredRelation.SameInsured || this.props.fetchFavoriteComplete}
                                  onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleBlur(e);
                                  }}
                                />
                                <div className="element__error-message">
                                  <ErrorMessage name="POLICYHOLDER_MOBILE" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td">
                              {/* 通訊地址 */}
                              <div className={'element__form-group' + ((errors.POLICYHOLDER_POST_CODE && touched.POLICYHOLDER_POST_CODE) || (errors.POLICYHOLDER_ADDRESS && touched.POLICYHOLDER_ADDRESS) || (errors.POLICYHOLDER_CITY_ID && touched.POLICYHOLDER_CITY_ID) || (errors.POLICYHOLDER_AREA_ID && touched.POLICYHOLDER_AREA_ID) ? ' element__form-group--invalid' : '')}>
                                <div className="element__form-group-title">通訊地址*</div>
                                <div className="element__form-group-content">
                                  <AddressComponent
                                    postCodeName="POLICYHOLDER_POST_CODE"
                                    postCodeId="policyholder-post-code-input"
                                    postCodeIdTabIndex={15}
                                    cityIdName="POLICYHOLDER_CITY_ID"
                                    cityId="policyholder-city-select"
                                    cityIdVal={values.POLICYHOLDER_CITY_ID}
                                    cityIdText="POLICYHOLDER_CITY_ID_NAME"
                                    cityIdTabIndex={16}
                                    areaIdName="POLICYHOLDER_AREA_ID"
                                    areaId="policyholder-area-select"
                                    areaNameVal={values.POLICYHOLDER_AREA_ID_NAME}
                                    areaIdText="POLICYHOLDER_AREA_ID_NAME"
                                    areaIdTabIndex={17}
                                    addressName="POLICYHOLDER_ADDRESS"
                                    addressId="policyholder-address-input"
                                    addressIdTabIndex={18}
                                    postcodes={this.state.postcodes}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    disabled={this.state.activeRelation === InsuredRelation.SameInsured && !this.props.fetchFavoriteComplete}
                                  />
                                </div>
                                <div className="element__error-message">
                                  {
                                    errors.POLICYHOLDER_POST_CODE
                                      ? <ErrorMessage name="POLICYHOLDER_POST_CODE" />
                                      : errors.POLICYHOLDER_CITY_ID
                                        ? <ErrorMessage name="POLICYHOLDER_CITY_ID" />
                                        : errors.POLICYHOLDER_AREA_ID
                                          ? <ErrorMessage name="POLICYHOLDER_AREA_ID" />
                                          : errors.POLICYHOLDER_ADDRESS
                                            ? <ErrorMessage name="POLICYHOLDER_ADDRESS" />
                                            : ''
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                          {values.POLICYHOLDER_RELATION !== InsuredRelation.SameInsured && (
                            <div className="element__form-table-tr">
                              <div className="element__form-table-td">
                                {values.POLICYHOLDER_NATIONALITY_TYPE !== NationalType.Legal ? (
                                  <>
                                    {/* 職業類別 */}
                                    <div className={'element__form-group' + (errors.POLICYHOLDER_JOB_NUMBER && touched.POLICYHOLDER_JOB_NUMBER ? ' element__form-group--invalid' : '')}>
                                      <div className="element__form-group-title">職業類別*</div>
                                      <Field
                                        as="select"
                                        name="POLICYHOLDER_JOB_NUMBER"
                                        data-fieldname="POLICYHOLDER_JOB_NUMBER"
                                        tabIndex={8}
                                        className="element__select"
                                        autoComplete="off"
                                      >
                                        <option value="">請選擇</option>
                                        <option value="1" title="政府機關公務人員 (不含國營事業)">政府機關公務人員 (不含國營事業)</option>
                                        <option value="2" title="本國學生">本國學生</option>
                                        <option value="3" title="一般職業人員 (不含本欄其他列舉職業人員)">一般職業人員 (不含本欄其他列舉職業人員)</option>
                                        <option value="5" title="高風險之行職業宜參考國家洗錢審查及資武擴風險評估報告所列之高及非常高行業，2024年國家洗錢資恐及資武擴風險評估報告所列高及非常高行業類別如下：國際金融業務分行(OBU)、提供虛擬資產服務之事業或人員、本國銀行、國際證券業務分公司(OSU)、外國銀行在臺分行、國際保險業務分公司(OIU)、證券商、銀樓業、辦理儲金匯兌之郵政機構、人壽保險公司、會計師、律師、提供第三方支付服務之事業或人員、不動產經紀業、農業金融機構(含全國農業金庫、農會信用部及漁會信用部)。">高風險職業</option>
                                      </Field>
                                      <div className="element__error-message">
                                        <ErrorMessage name="POLICYHOLDER_JOB_NUMBER" />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    {/* 現金密集型行業 */}
                                    <div className={'element__form-group' + (errors.POLICYHOLDER_JOB_NUMBER && touched.POLICYHOLDER_JOB_NUMBER ? ' element__form-group--invalid' : '')}>
                                      <div className="element__form-group-title">現金密集型行業*</div>
                                      <Field
                                        as="select"
                                        name="POLICYHOLDER_JOB_NUMBER"
                                        data-fieldname="POLICYHOLDER_JOB_NUMBER"
                                        tabIndex={8}
                                        className="element__select"
                                        autoComplete="off"
                                      >
                                        <option value="">請選擇</option>
                                        <option value="1" title="國營事業">國營事業</option>
                                        <option value="2" title="本國金融業 (銀行、證券、期貨、投信、保險)">本國金融業 (銀行、證券、期貨、投信、保險)</option>
                                        <option value="3" title="一般公司">一般公司</option>
                                        <option value="4" title="租賃公司">租賃公司</option>
                                        <option value="5" title="藝術品收藏、骨董、拍賣、博奕、珠寶及貴金屬、典當、軍火、融資、基金會、協會、寺廟、匯款、外幣兌換、大使館、辦事處、虛擬貨幣交易">高風險行業</option>
                                      </Field>
                                      <div className="element__error-message">
                                        <ErrorMessage name="POLICYHOLDER_JOB_NUMBER" />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 保單寄送方式 */}
                  <div className="delivery">
                    <div className="delivery__title">保單寄送方式</div>
                    <div className="delivery__content">
                      <div className="element__form-group">
                        <div className="element__form-group-content">
                          {policyDeliveryArea}
                          {this.state.policyDeliverySysOpts.length === 2 &&
                            <>
                              <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U019)}</p>
                              <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U052)}</p>
                            </>}
                          {(this.state.policyDeliverySysOpts.length === 1 && this.state.policyDeliverySysOpts[0].PARAM_VALUE === PolicyDelivery.Electric)
                            ? <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U019)}</p>
                            : (this.state.policyDeliverySysOpts.length === 1)
                              ? <p>{commonService.getCodeMsg(this.props.UICodes, CodeId.U052)}</p>
                              : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="insure-process-fill__controls">
                  <button type="button" className="element__button element__button--red-border" onClick={() => this.handleGoBack(values)}>返回上一頁</button>
                  <button type="submit" className="element__button element__button--red">下一步</button>
                </div>
                <FormikFocusError />
                <MemberInfoErrorModal />
              </Form>
            )
          }
        </Formik>
      </div>
    );
  }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setRuleValidErrorModalVisible: (visible: boolean, errorMsgs: any[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs)),
    setMemberInfoErrorModalVisible: (visible: boolean, title?: string, content?: string, fieldNames?: string[]) => dispatch(setMemberInfoErrorModalVisible(visible, title, content, fieldNames))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(InsureProcessFill);
